"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(_ref) {
  var organisationId = _ref.organisationId,
      inspirationId = _ref.inspirationId;
  return "organisation/".concat(organisationId, "/inspiration/").concat(inspirationId, "/file-THUMBNAIL");
};

exports.default = _default;